"use client";

import { MessageChannel } from "@prisma/client";
import { createContext, ReactNode, useContext } from "react";
import { CallPeriod } from "@/app/types/call/CallPeriod";
import { WorkspaceSelection } from "@/app/types/common/WorkspaceSelection";
import { PROSPECT_ACTION_FILTER_ALL } from "@/app/types/prospect/ProspectActionFilter";
import { ProspectListTab } from "@/app/types/prospect/ProspectListTab";

const DEFAULT_SELECTION: WorkspaceSelection = {
  channel: MessageChannel.LINKEDIN,
  period: CallPeriod.ALL,
  periodRange: {},
  prospectTab: ProspectListTab.ALL,
  prospectActionFilter: PROSPECT_ACTION_FILTER_ALL,
};

const SelectionContext = createContext<WorkspaceSelection>(DEFAULT_SELECTION);

type Props = {
  selection: WorkspaceSelection;
  children: ReactNode;
};

export default function SelectionProvider(props: Props) {
  const { selection, children } = props;

  return <SelectionContext.Provider value={selection}>{children}</SelectionContext.Provider>;
}

export function useInitialSelection(): WorkspaceSelection {
  return useContext(SelectionContext);
}
